import React, { useContext } from "react";
import { View, Dimensions, Image, StatusBar } from "react-native";
import ThemeContext from "@presto-contexts/ThemeContext";
import _ from "lodash";
import { useAssets } from "presto-react-components";
import { useSafeArea } from "react-native-safe-area-context";
import utils from "../../utils";

export default function GradientBackgroundForHeader({ user }) {
  const { images } = useAssets();
  const { theme } = useContext(ThemeContext);
  const insets = useSafeArea();
  const windowWidth = Dimensions.get("window").width;
  const tier = _.toLower(_.get(user, "loyalty_tier_name", ""));
  let userTierImage = null;
  if (tier === "gold") {
    userTierImage = images.loyaltyTierGoldBackground;
  } else if (tier === "silver") {
    userTierImage = images.loyaltyTierSilverBackground;
  } else if (tier === "bronze") {
    userTierImage = images.loyaltyTierBronzeBackground;
  }
  console.log(userTierImage, "lkjfdasfoijsdiofjs1234");
  if (!userTierImage) {
    // return null;
    <View
      style={{
        position: "absolute",
        width: windowWidth,
        backgroundColor: theme?.primary,
        height: insets.top + 60,
        ...(utils.isMobileWeb() && {
          top: 0,
        }),
      }}
    ></View>;
  }
  console.log(utils.isDesktop(), "lkjfdasfoijsdiofjs");
  return (
    <View
      style={{
        position: "absolute",
        width: windowWidth,
        height: insets.top,
        ...(utils.isMobileWeb() && {
          top: 0,
        }),
        ...(utils.isDesktop() && { top: 0 }),
      }}
    >
      <Image
        source={userTierImage}
        style={{
          width: "100%",
          height:
            utils.isMobileWeb() || utils.isDesktop()
              ? insets.top + 70
              : insets.top + 60,
        }}
      />
    </View>
  );
}
